import { Theme } from '@mui/material';

import { Maybe } from '@shared-components/types';

export const blogListContainerStyles = {
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	paddingY: { xs: '1.25rem', md: '1rem', lg: '1.75rem' },
};

export const blogListTitlerContainerStyles = {
	width: '100%',
	paddingX: { xs: '1.25rem', md: '2%', lg: '5%', xl: '6rem' },
	paddingTop: { xs: '1.25rem', md: '1rem', lg: '1.75rem' },
};

const getGridCount = (defaultCount: number, newCount?: Maybe<number>) => {
	const count = newCount ?? defaultCount;
	return `repeat(${count}, 1fr)`;
};

export const getBlogListItemContainerStyles = (
	countAcrossDesktop?: Maybe<number>,
	countAcrossMobile?: Maybe<number>
) => ({
	display: 'grid',
	gridTemplateColumns: {
		xs: getGridCount(2, countAcrossMobile),
		md: getGridCount(3, countAcrossDesktop),
		lg: getGridCount(4, countAcrossDesktop),
	},
	gridColumnGap: { xs: '.75rem', lg: '1.25rem' },
	gridRowGap: { xs: '1.75rem', lg: '2.5rem' },
	width: '100%',
});

export const showMoreBoxStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	marginTop: '3rem',
	gap: '.75rem',
};

export const getPaginationStyles = (theme: Theme) => ({
	'.MuiPagination-ul .MuiPaginationItem-root': {
		padding: '0 .15rem',
		margin: '0 .5rem',
		width: 'auto',
		minWidth: '0',
		borderRadius: 0,
		alignItems: 'center',
	},
	'.MuiPagination-ul .Mui-selected': {
		backgroundColor: 'transparent',
		borderBottom: '1px solid',
		borderColor: theme.palette.accent01?.main,
		borderRadius: 0,
	},
});
